import React from 'react';
import { Typography, Row, Col } from 'antd';
import { CSVLink, UploadDragger } from '@common/components';
import { RcFile } from 'antd/lib/upload';

const { Text } = Typography;

const csvTemplateContent = [
  [
    'first_name',
    'last_name',
    'email',
    'employee_id',
    'phone_number',
    'time_zone',
    'role_abbreviation',
    'group',
    'home_unit',
    'other_units',
  ],
  [
    'Example',
    'Name',
    'exampleworker@trustedhealth.com',
    '12345678',
    '123-123-1234',
    'America/Los_Angeles',
    'RN',
    'Group Name',
    'Unit Name',
    'Other Unit Names',
  ],
];

type Props = {
  csvFile: RcFile | null;
  handleFileUpload: (file: RcFile) => boolean;
};

export function WorkerUploadFileUploadStep({
  csvFile,
  handleFileUpload,
}: Props) {
  return (
    <div className="worker-upload-file-upload-step">
      <Row>
        <Col span={24} style={{ marginBottom: 24 }}>
          <Text>
            <CSVLink data={csvTemplateContent} fileName="staff_upload_template">
              Download the template
            </CSVLink>{' '}
            to upload staff into Works.
          </Text>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <UploadDragger
            accept=".csv"
            fileList={csvFile ? [csvFile] : []}
            beforeUpload={handleFileUpload}
            hideActions={true}
          />
        </Col>
      </Row>
      <style jsx>{`
        .worker-upload-file-upload-step :global(h1.ant-typography) {
          font-size: 30px;
        }
        .worker-upload-file-upload-step :global(span.ant-typography) {
          font-size: 16px;
        }
      `}</style>
    </div>
  );
}
